import Components from '../Components';
import Form from '../Form'
import StickSidebar from '../StickSidebar';
import Factory from "../Factory";

export default function (el) {
	// Opções selecionadas
	let getInputs = (all) => {
		let selector = all
			? ' .sl-category-config-form input'
			: ' .sl-category-config-form .sl-config-print-options input';

		let values = {};
		$(selector, el).each((event, element) => {
			if ( $(element).is('.finish-input') ) {
				// Pega o nome do input
				let name = $(element).attr('name');
				// Tira o grupo do nome do input
				let compiledName = name.replace(/^([^\[]*)\[.*$/, "$1");
				// Caso nao tenha a lista, cria
				if ( Array.isArray(values[compiledName]) == false ) {
					values[compiledName] = [];
				}
				// Caso esteja selecionado, adiciona na lista
				if ( element.checked ) {
					values[compiledName].push( $(element).val() );
				}
			}
			else if ($(element).attr('type') === "radio") {
				if(element.checked) {
					values[$(element).attr('name')] = $(element).val();
				}
			} else {
				values[$(element).attr('name')] = $(element).val();
			}
		});

		values['custom_quantity_input'] = values['custom_quantity'];
		delete values['custom_quantity'];

		let productChecked = $("input[name='product']:checked", el).parent();
		if ( productChecked.length ) {
			values['peso']  = parseFloat(productChecked.data('peso'));
			values['modulos']  = parseFloat(productChecked.data('modulos'));
			values['valor'] = parseFloat(productChecked.find('.sl-checkbox-label').text().replace('R$ ', '').replace(',', '.'));
			values['custom_quantity'] = productChecked.data('qtde') ? parseInt(productChecked.data('qtde')) : null;
		}

		values['category_id'] = $('div[data-category]').attr('data-category');
		return values;
	};

	let configChanged = (event) => {
		let inputs = getInputs();
		let data = $(el).data();
		let params = $(el).closest('.sl-component').find('input[name="params"]').val();

		let input = $('.sl-config-print-options [name="configuration_format"]:checked');

		if(input.attr('name') == 'configuration_format' && input.val() == 'custom') {
			$(' .sl-sob-medida', el).fadeIn('fast');

			let width_input = $('.sl-sob-medida [name="sob_medida_width"]', el),
				height_input = $('.sl-sob-medida [name="sob_medida_height"]', el);

			let width = width_input.val(),
				height = height_input.val(),
				width_min = parseInt(width_input.attr('data-min')),
				width_max = width_input.attr('data-max'),
				height_min = parseInt(height_input.attr('data-min')),
				height_max = height_input.attr('data-max');

			width_max = (width_max == '') ? 999999 : parseInt(width_max);
			height_max = (height_max == '') ? 999999 : parseInt(height_max);

			if(width == '' || height == '') {
				return;
			}

			if(width < width_min || height < height_min || width > width_max || height > height_max) {
				$(' .sl-sob-medida .sl-message', el).addClass('sl-error')
				return;
			} else {
				$(' .sl-sob-medida .sl-message', el).removeClass('sl-error')
			}
		} else {
			$(' .sl-sob-medida', el).fadeOut('fast');
		}

		input = $('.pages input[name="configuration_pages"]');
		let valor = parseFloat(input.val());
		let min = input.attr('data-minimum');
		let max = input.attr('data-maximum');
		if(valor < min || valor > max || valor == ""){
			$('.pages .sl-checkbox', el).addClass('sl-errors');
			return;
		}else{
			$('.pages .sl-checkbox', el).removeClass('sl-errors');
			inputs["configuration_pages"] = input.val();
		}

		updateUrl( inputs );

		Components.loading(el);
		$.ajax({
			method: "POST",
			url: wp.ajax_url,
			data: {
				action: 'sl_category_config',
				inputs,
				data,
				params,
			}
		}).done((response) => {
			$('.sl-config-print-options', el).html(response);
			updateSidebar();
			getProducts();
		});
	};

	let requestCustomQuantity = (event) => {
		let inputs = getInputs(true);
		let data = $(el).data();
		let params = $(el).closest('.sl-component').find('input[name="params"]').val();

		Components.loading(el);
		$.ajax({
			method: "POST",
			url: wp.ajax_url,
			data: {
				action: 'sl_category_custom_quantitry',
				inputs,
				data,
				params,
			}
		}).done((response) => {
			$('.sl-config-print-prices .sl-prices-table > table', el).append(response);
			updateSidebar();
			Components.loading(el, 'stop');
		});
	};

	let registerEvents = () => {
		function configCampoMedida( campo ) {
			campo.mask(
				"000.00",
				{
					reverse: true,
					onChange: function( medida ){
						let replaces = [
							// Tira os 0 à esquerda
							[/^0+([0-9]+[\.,])/, "$1"],
							// Caso não tenha nenhum número, ele adiciona o 0.
							[/^([0-9]+)$/, "0.$1"],
							// Quando não tiver nada, volta para 0.00
							[/^$/, "0.00"]
						];
						let medidaMudada = medida;
						replaces.forEach(function (r) {
							medidaMudada = medidaMudada.replace(r[0], r[1]);
						})
						campo.val(medidaMudada);
					},
				}
			);
			if ( campo.val() == "" ) {
				campo.val( "0.00" )
			}
		}
		configCampoMedida($('[name="sob_medida_width"]',  el));
		configCampoMedida($('[name="sob_medida_height"]', el));

		$('.art [type="radio"]', el).off('change');
		$('.sl-painel sl-painel-body > :not(.art) [type="radio"]', el).off('click');
		$('.sl-config-print-prices [name="product"]', el).off('change');
		$('#sl-custom-quantity-send', el).off('click');
		$('.sl-config-print-options [type="radio"]', el).off('change');
		$('.sl-config-print-options [type="checkbox"]', el).off('change');
		$('#sl-sob-medida-send', el).off('click');
		$('#sl-paginas-send', el).off('click');
		$('.sl-painel [type="radio"]', el).off('change');

		$('.art [type="radio"]', el).change(getProducts);
		$('.sl-painel sl-painel-body > :not(.art) [type="radio"]', el).click(uncheckRadio);
		$('.sl-config-print-prices [name="product"]', el).change(checkProduct);
		$('#sl-custom-quantity-send', el).click(requestCustomQuantity);
		$('.sl-config-print-options [type="radio"]', el).change(configChanged);
		$('.sl-config-print-options [type="checkbox"]', el).change(configChanged);
		$('#sl-sob-medida-send', el).click(configChanged);
		$('#sl-paginas-send', el).click(configChanged);
		$('[name="configuration_pages"]', el).focusout(configChanged);
		$('.sl-painel [type="radio"]', el).change(controlActiveSteps);

		// Previne enter no input e quantdade customizada
		$('.sl-custom-quantity input', el).keydown(function (e) {
			if (e.keyCode == 13) {
				$('#sl-custom-quantity-send', el).click();
				e.preventDefault();
				return;

			}

			var validKeys = [
				// Numbers
				'1','2','3','4','5','6','7','8','9','0',
				// Text deletion
				'Backspace','Delete',
				// Text location
				'ArrowLeft', 'ArrowRight', 'Home','End',
			];

			var key = event.key;
			if ( validKeys.includes(key) == false ) {
				console.log("Key \""+key+"\" is a invalid caractere");
				e.preventDefault();
			}
		});

		$('.pages input', el).keydown(function (e) {
			var validKeys = [
				// Numbers
				'1','2','3','4','5','6','7','8','9','0',
				// Text deletion
				'Backspace','Delete',
				// Text location
				'ArrowLeft', 'ArrowRight', 'Home','End',
			];
			var numberKeys = ['1','2','3','4','5','6','7','8','9','0'];
			var key = event.key;
			if ( validKeys.includes(key) == false ) {
				console.log("Key \""+key+"\" is a invalid caractere");
				e.preventDefault();
				return;
			}else{
				if (e.keyCode == 13) {
					e.preventDefault();
					return;
				}	
			}
		});
	};

	let checkOptions = () => {
		let all_check = 0;
		if ($('[name="configuration_pages"]').val() != undefined ) {
			all_check = $('[name="configuration_pages"]').val() == "" ? 0 : 1;
		}
		$(' .sl-config-print-options .sl-listing', el).each((event, element) => {
			let radios = $(' .sl-checkbox > [type="radio"]', element).length;
			let checked = $(' .sl-checkbox > [type="radio"]:checked', element).length > 0;
			if (radios > 0 && checked) {
				all_check++;
			}
		});

		return $('[name="configuration_pages"]').val() != undefined  ? (all_check >= 5) : (all_check >= 4);
	};

	let getProducts = () => {
		$('.sl-gabarito').fadeOut();
		if(checkOptions()) {
			Components.loading(el);
			let inputs = getInputs();
			let productChecked = $("input[name='product']:checked", el).parent();
			let data = $(el).data();
			let params = $(el).closest('.sl-component').find('input[name="params"]').val();
			$.ajax({
				method: "POST",
				url: wp.ajax_url,
				data: {
					action: 'sl_category_config_prices',
					inputs,
					data,
					params
				}
			}).done((response) => {
				$(' .sl-config-print-prices', el).html(response);
				controlActiveSteps(false);
				registerEvents();
				Components.loading(el, 'stop');
				if ( productChecked.length ) {
					let p = productChecked.find('[name="product"]').val();
					$(' .sl-config-print-prices [name="product"][value="'+p+'"]', el).click();
				}
			});
		} else {
			$(' .sl-config-print-prices', el).html('');
			registerEvents();
			Components.loading(el, 'stop');
		}
	};

	let formSubmit = () => {
		$('.sl-category-config-form [type="submit"]', el).prop("disabled", false);

		let rules = [
			Factory.rule('art', 'Por favor, selecione como deseja enviar sua arte!'),
			Factory.rule('product', 'Por favor, selecione o prazo e a quantidade.'),
		];

		new Form(el, rules, () => {
			Components.loading(el);
			let data = getInputs(true);
			$.ajax({
				method: "POST",
				url: wp.ajax_url,
				data: {
					action: 'sl_category_config_add',
					data
				}
			}).done((response) => {
				if(response.response) {
					window.location = response.redirect;
				}
			});
		});
	};

	let controlActiveSteps = (event) => {
		updateSidebar();

		let step2 = $('.sl-config-content[data-configuration-step="2"]', el),
			step3 = $('.sl-config-content[data-configuration-step="3"]', el),
			target= $(event.target);

		let editedSteps = $(event.target).parents('.sl-config-content')
		if ( editedSteps.length ) {
			editedSteps.nextAll().removeClass('active');
			if ( editedSteps.nextAll().length ) {
				step3.find('.sl-prices-table').html('')
			}
		}

		if (event) event.stopPropagation();

		if($(' [name="art"]:checked', el).length > 0) {
			step2.addClass('active');
			if ( target.is('[name="art"]:checked') ) {
				$("html, body").animate({ scrollTop: ( checkOptions() ? step3 : step2 ).offset().top }, "slow");
			}
			updateUrl();
		} else {
			step2.removeClass('active');
			step3.removeClass('active');
		}

		if($('.sl-config-print-prices table tbody tr', el).length > 0) {
			step3.addClass('active');
		} else {
			step3.removeClass('active');
		}
	};

	function uncheckRadio() {
		let previousValue = $(this).data('previous-value'),
			name = $(this).data('name');

		if (previousValue === 'checked') {
			$(this).prop('checked', false);
			$(this).data('previous-value', false);
			$(this).change();
		} else {
			$("input[name="+name+"]:radio").data('previous-value', false);
			$(this).data('previous-value', 'checked');
		}
	}

	function checkProduct() {
		let product = $(this).parent('.sl-checkbox');

		let productDescription = product.data('description');
		let descriptionContent = $('.sl-config-sidebar', el).find('.description');

		if ( !productDescription ) {
			descriptionContent.removeClass('active');
		}
		else {
			descriptionContent
				.addClass('active')
				.find('.value')
				.html(product.data('description'));
		}

		if(product.data('sobmedida') != 1) {
			$('.sl-gabarito').fadeIn();
		}
	}

	function updateSidebar() {
		let inputs = getInputs();
		let step1 = $('.sl-config-content[data-configuration-step="1"]', el);
		let step2 = $('.sl-config-content[data-configuration-step="2"]', el);
		let pages_selected = step2.find('.paper input:checked').next();
		let sidebar = $('.sl-config-sidebar', el);
		let config = {
			productName: sidebar.find('.product-name'),
			art: sidebar.find('.art'),
			format: sidebar.find('.format'),
			color: sidebar.find('.color'),
			paper: sidebar.find('.paper'),
			pages: sidebar.find('.pages'),
			ennoblement: sidebar.find('.ennoblement'),
			finishing: sidebar.find('.finishing'),
		};
		let values = {
			art: step1.find('.art input:checked').attr('data-value'),
			format: step2.find('.format input:checked').val(),
			color: step2.find('.color input:checked').val(),
			paper: step2.find('.paper input:checked').data('value'),
			pages: step2.find('.pages input').val(),
			ennoblement: step2.find('.ennoblement input:checked').data('description'),
			finishing: jQuery.map(
				step2.find('.finishing input:checked'),
				// Pega o texto dos checados
				v => $(v).parent().find('.sl-checkbox-label').text()
			),
		};
		Object.keys(values).forEach(key => {
			if(values[key] === undefined) {
				config[key].removeClass('active');
				return;
			}


			if (key == 'format') {
				if(values[key] != 'custom') {
					config[key].find('.value').html(values[key] +'cm');
				}
				else {

					let width_input = $('.sl-sob-medida [name="sob_medida_width"]', el);
					let height_input = $('.sl-sob-medida [name="sob_medida_height"]', el);
					let medida = width_input.val() + ('x') + height_input.val() + 'cm';

					if (medida == '0.00x0.00cm') {
						config[key].find('.value').html('Insira a medida');

					}
					else {
						config[key].find('.value').html(medida);
					}
				}
			} else if ( key == 'finishing' ) {
				if(values[key].length == 0) {
					config[key].removeClass('active');
					return;
				}
				config[key].find('.value').html('<br>'+values[key].join('<br>'));
			} else {
				config[key].find('.value').html(values[key]);
			}

			config[key].addClass('active');
		});

		let productChecked = $("input[name='product']:checked", el).parent();
		if ( productChecked.length ) {
			var valor = $('[name="art"]:checked', el).data("price") ?$('[name="art"]:checked', el).data("price"): 0.0;
			var valorAdic = $('[name="art"]:checked', el).data("adic-price") ?$('[name="art"]:checked', el).data("adic-price"): 0.0;
			let sidebarCustos = sidebar.find('.custos');
			var prod = sidebarCustos.find('.custo_prod');
			var arte = sidebarCustos.find('.custo_arte');
			var final = sidebarCustos.find('.custo_final');
			var custoArte = parseFloat(valor.replace(",","."));
			var custoAdicArte = parseFloat(valorAdic.replace(",","."));
			var custoAdicArte = inputs['modulos'] * custoAdicArte;
			custoArte += custoAdicArte;

			var total = custoArte + inputs['valor'];
			sidebarCustos.css("display","block");
			if(custoArte > 0){
				arte.html("<strong>Arte:</strong> R$"+custoArte.toFixed(2));
			}
			prod.html("<strong>Produto: </strong>R$"+inputs['valor'].toFixed(2));
			final.html("<strong>Total: </strong>R$"+total.toFixed(2));
			sidebar.find('.custos').show();
		}
		else {
			sidebar.find('.description').removeClass('active');
			sidebar.find('.custos').hide();
		}
	}

	function getUrlParams() {
		return {
			'configuration_format': 'formato',
			'configuration_color': 'cor',
			'configuration_paper': 'papel',
			'configuration_pages': 'pages',
			'configuration_ennoblement': 'enobrecimento',
			'configuration_finishing': 'acabamento',
			'configuration_art': 'arte',
		};
	}

	function updateUrl( inputs ) {
		if ( inputs === undefined ) inputs = getInputs();

		inputs.configuration_art = $(el).find('.art input:checked').val();

		let keysParametros = getUrlParams();

		let inputsFormatadosParametros = {};
		for (var key in inputs) {
			if ( keysParametros.hasOwnProperty( key ) ) {
				if ( key == 'configuration_finishing' ) {
					inputsFormatadosParametros[ keysParametros[key] ] = inputs[key].join();
				}
				else if ( key == 'configuration_format' && inputs[key] == 'custom' ) {
					inputsFormatadosParametros[ keysParametros[key] ] = 'custom:'+inputs['sob_medida_width']+'x'+inputs['sob_medida_height'];
				}
				else {
					inputsFormatadosParametros[ keysParametros[key] ] = inputs[key];
				}
			}
		}

		var str = "";
		for (var key in inputsFormatadosParametros) {
			if (str != "") {
				str += "&";
			}
			str += key + "=" + encodeURIComponent(inputsFormatadosParametros[key]);
		}
		window.history.replaceState(inputsFormatadosParametros, '', window.location.pathname + '?' + str);
	}

	registerEvents();
	if ($('#sl-paginas-send')) {
		$('#sl-paginas-send').click()
	}
	formSubmit();

	controlActiveSteps(false);

	if ($(window).width() > '768') {
		new StickSidebar($('.sl-config-sidebar .sidebar-inner', el));
	}

}
